import script from "./ActivityLog.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityLog.vue?vue&type=script&setup=true&lang=js"

import "./ActivityLog.vue?vue&type=style&index=0&id=345eee52&scoped=true&lang=css"

import exportComponent from "/var/www/app/resources/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-345eee52"]])

export default __exports__